function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      const accordion = event.currentTarget;
      const currentToggle = event.target.closest('.accordion__summary');
      if (!currentToggle) return;
      const panelId = currentToggle.getAttribute('aria-controls');
      const currentPanel = accordion.querySelector(`#${panelId}`);
      const toggles = accordion.querySelectorAll('.accordion__summary');
      const panels = accordion.querySelectorAll('.accordion__content');

      toggles.forEach((toggle) => {
        if (toggle !== currentToggle) {
          toggle.setAttribute('aria-expanded', false);
        }
      });
      panels.forEach((panel) => {
        if (panel === currentPanel) {
          const ariaState = currentToggle.getAttribute('aria-expanded');
          if (ariaState === 'true') {
            currentToggle.setAttribute('aria-expanded', false);
            panel.classList.remove('is-open');
          } else {
            currentToggle.setAttribute('aria-expanded', true);
            panel.classList.add('is-open');
          }
        } else {
          panel.classList.remove('is-open');
        }
      });
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();

    document.addEventListener('cart-drawer:opened', this.onDrawerOpened.bind(this));
    document.addEventListener('header-drawer:opened', this.onDrawerOpened.bind(this));
    document.addEventListener('modal-dialog:opened', this.onDrawerOpened.bind(this));
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.reset__button):not(.search__button):not([data-regionalisation-trigger]):not([data-newsletter-trigger]):not(.newsletter-form__button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const allSummaryElements = parentMenuElement && parentMenuElement.querySelectorAll('.menu-drawer__menu-item');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const addTrapFocus = () => {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    };

    const cleanCloseDesktopMenus = (detailsElement) => {
      // close this sub menu
      detailsElement.classList.remove('is-open');
      allSummaryElements.forEach((summary) => summary.setAttribute('aria-expanded', false));
      summaryElement.setAttribute('aria-expanded', false);
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');

      setTimeout(() => {
        detailsElement.removeAttribute('open');
        removeTrapFocus(summaryElement);
      }, 250);

      // Propperly close child menus also
      detailsElement.querySelectorAll('details').forEach((details) => {
        details.classList.remove('is-open');
        details.classList.remove('menu-opening');
        setTimeout(() => {
          details.removeAttribute('open');
        }, 100);
      });
    };

    const cleanOpenDesktopMenus = (detailsElement, mainDetailsToggle) => {
      const openSubMenus = mainDetailsToggle.querySelectorAll('details[open]');

      openSubMenus.forEach((openSubMenu) => {
        if (detailsElement.closest('details[open]') == openSubMenu) return;
        if (detailsElement == openSubMenu) return;
        cleanCloseDesktopMenus(openSubMenu);
      });

      detailsElement.setAttribute('open', true);
      setTimeout(() => {
        detailsElement.classList.add('is-open');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        addTrapFocus();
      }, 100);
    };

    const resetAncestorMenus = () => {
      this.mainDetailsToggle.querySelectorAll('.menu-drawer__submenu').forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    };

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      if (window.matchMedia('(min-width: 1200px)').matches) {
        event.preventDefault();
        if (isOpen) {
          cleanCloseDesktopMenus(detailsElement);
        } else {
          cleanOpenDesktopMenus(detailsElement, this.mainDetailsToggle);
          resetAncestorMenus(detailsElement);
        }
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');

      const event = new CustomEvent('menu-drawer:opened', {
        bubbles: true,
        detail: { elementToFocus: summaryElement },
      });
      document.dispatchEvent(event);
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    const activeModals = document.querySelectorAll(
      '.drawer-modal[open], .drawer.active, .menu-drawer-container[open], menu-drawer > [open]'
    );

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.classList.remove('is-open');
      details.classList.remove('menu-opening');
      setTimeout(() => {
        details.removeAttribute('open');
      }, 100);
    });
    this.mainDetailsToggle.querySelectorAll('summary').forEach((summary) => {
      summary.setAttribute('aria-expanded', false);
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    if (activeModals.length <= 1) {
      document.body.classList.remove('overflow-hidden');
    }
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement && detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    if (detailsElement) {
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    }
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  onDrawerOpened(evt) {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');

    if (isOpen) {
      const { elementToFocus } = evt.detail;
      this.closeMenuDrawer(evt, elementToFocus);
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.menuTrigger = this.querySelector('.header__icon--menu');
    this.mainDetailsElement = this.querySelector('.menu-drawer-container');
    this.searchTrigger = document.querySelector('.search__trigger');
    this.fauxSearchTrigger = document.querySelector('.search__trigger--faux');
    this.menuDrawer = this.querySelector('.menu-drawer');
    this.header = document.querySelector('.header-wrapper');

    document.addEventListener('cart-drawer:opened', this.onDrawerOpened.bind(this));
    document.addEventListener('menu-drawer:opened', this.onDrawerOpened.bind(this));
    document.addEventListener('modal-dialog:opened', this.onDrawerOpened.bind(this));

    this.mediaQuery = window.matchMedia('(min-width: 750px)');
    this.mediaQuery.addEventListener('change', this.onMediaQueryChange.bind(this));
    this.onMediaQueryChange(this.mediaQuery);
  }

  connectedCallback() {
    const inputEl = this.querySelector('.search__input');
    if (this.searchTrigger) {
      this.searchTrigger.addEventListener('click', (evt) => {
        this.handleSearchTriggerClick(evt, inputEl, false);
      });
    }

    if (this.fauxSearchTrigger) {
      this.fauxSearchTrigger.addEventListener('click', (evt) => {
        this.handleSearchTriggerClick(evt, inputEl, true);
      });
    }

    document.addEventListener('menu-drawer:opened', () => {
      this.mainDetailsElement.classList.remove('prevent-animation');
    });
  }

  handleSearchTriggerClick(evt, inputEl, preventAnimation) {
    const isOpen = this.mainDetailsElement.hasAttribute('open');
    if (!isOpen) {
      // Open drawer
      this.menuTrigger.click();
      // reveal search
      this.classList.add('search-expanded');
      this.searchTrigger.classList.add('active');
      if (preventAnimation) {
        this.mainDetailsElement.classList.add('prevent-animation');
      }

      setTimeout(() => {
        inputEl?.focus();
      }, 300);
    } else if (this.classList.contains('search-expanded')) {
      // Close search and details drawer
      this.classList.remove('search-expanded');
      this.closeMenuDrawer(evt, this.menuTrigger);
      this.searchTrigger.classList.remove('active');
      if (preventAnimation) {
        this.mainDetailsElement.classList.remove('prevent-animation');
      }
    } else {
      // switch to search
      this.classList.add('search-expanded');
      this.searchTrigger.classList.add('active');
      if (preventAnimation) {
        this.mainDetailsElement.classList.add('prevent-animation');
      }

      this.cleanCloseDesktopMenus(this.mainDetailsElement);

      setTimeout(() => {
        inputEl?.focus();
      }, 100);
    }
  }

  cleanCloseDesktopMenus(detailsElement) {
    const parentMenuElement = detailsElement.closest('.has-submenu');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.querySelectorAll('details').forEach((details) => {
      details.classList.remove('is-open');
      details.classList.remove('menu-opening');
      // timeout is needed to prevent glitches when menu is re-opened
      setTimeout(() => {
        details.removeAttribute('open');
      }, 100);
    });
  }

  onSummaryClick(event) {
    const currentSummary = event.currentTarget;
    const actualClickedElement = event.target;
    const searchIsActive = this.classList.contains('search-expanded');
    if (
      searchIsActive &&
      actualClickedElement.classList.contains('header__icon--menu-inner') &&
      actualClickedElement.parentNode === currentSummary
    ) {
      this.classList.remove('search-expanded');
      setTimeout(() => {
        this.openMenuDrawer(currentSummary);
        this.mainDetailsElement.setAttribute('open', true);
      }, 0);
    } else {
      super.onSummaryClick(event);
    }
  }

  openMenuDrawer(summaryElement) {
    const event = new CustomEvent('header-drawer:opened', {
      bubbles: true,
      detail: { elementToFocus: summaryElement },
    });
    document.dispatchEvent(event);

    this.setHeaderBottomPosition();

    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    if (this.classList.contains('search-expanded')) {
      const inputEl = this.querySelector('.search__input');
      // I believe timeout is needed because we can't focus off-screen elements
      setTimeout(() => {
        inputEl.focus();
      }, 100);
    }

    trapFocus(this.mainDetailsToggle, summaryElement);

    document.body.classList.add('overflow-hidden');
    this.header.classList.remove('show-faux-search-bar');
  }

  closeMenuDrawer(event, elementToFocus) {
    this.mainDetailsElement.classList.remove('prevent-animation');
    this.searchTrigger.classList.remove('active');
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);

    this.header.classList.remove('menu-open');

    this.classList.remove('search-expanded');
  }

  setHeaderBottomPosition() {
    this.header = this.header || document.querySelector('.header-wrapper');
    this.borderOffset = this.borderOffset || this.header.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
  }

  onMediaQueryChange(event) {
    if (event.matches) {
      this.setHeaderBottomPosition();
    } else {
      this.setHeaderBottomPosition();
    }
  }

  onDrawerOpened = (evt) => {
    const isOpen = this.mainDetailsElement.hasAttribute('open');

    if (isOpen) {
      const { elementToFocus } = evt.detail;
      this.closeMenuDrawer(evt, elementToFocus);
    }
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('cart-drawer:opened', this.onDrawerOpened.bind(this));
    document.addEventListener('header-drawer:opened', this.onDrawerOpened.bind(this));
    document.addEventListener('menu-drawer:opened', this.onDrawerOpened.bind(this));
    document.addEventListener('modal-dialog:opened', this.onDrawerOpened.bind(this));

    this.openOnLoadIfParameterPresent();
    this.header = document.querySelector('.header-wrapper');

    this.addCloseEventListeners('.ss__sort__link');

    this.mediaQuery = window.matchMedia('(min-width: 750px)');
    this.mediaQuery.addEventListener('change', this.onMediaQueryChange.bind(this));
    this.onMediaQueryChange(this.mediaQuery);
  }

  connectedCallback() {
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
    document.body.addEventListener('AddressModalClosed', () => {
      this.hide();
    });

    if ('inline' in this.dataset || this.parentElement === document.body) return;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    if (!('inline' in this.dataset)) {
      document.body.classList.add('overflow-hidden');
      this.header.classList.remove('show-faux-search-bar');
    }
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));

    const event = new CustomEvent('modal-dialog:opened', {
      bubbles: true,
      detail: { elementToFocus: this },
    });
    document.dispatchEvent(event);

    this.setHeaderBottomPosition();
  }

  hide() {
    const activeModals = document.querySelectorAll(
      '.drawer-modal[open], .drawer.active, .menu-drawer-container[open], menu-drawer > [open]'
    );
    if (!('inline' in this.dataset) && activeModals.length <= 1) {
      document.body.classList.remove('overflow-hidden');
    }
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(!('inline' in this.dataset) && this.openedBy);
  }

  onDrawerOpened(evt) {
    if (evt.detail.elementToFocus === this) return;

    const isOpen = this.hasAttribute('open');
    if (isOpen) {
      this.hide();
    }
  }

  openOnLoadIfParameterPresent() {
    const url = new URL(window.location.href);
    const query = url.search + url.hash;
    const dataOpenQuery = this.dataset.openQuery;

    if (dataOpenQuery && query.includes(dataOpenQuery)) {
      window.addEventListener('load', () => {
        this.show();
      });
    }
  }

  addCloseEventListeners(selector) {
    this.addEventListener('click', (event) => {
      if (event.target.matches(selector) || event.target.closest(selector)) {
        this.hide();
      }
    });
  }

  setHeaderBottomPosition() {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.header.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
  }

  onMediaQueryChange(event) {
    if (event.matches) {
      this.setHeaderBottomPosition();
    } else {
      this.setHeaderBottomPosition();
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      const panelId = this.getAttribute('data-panel');
      if (modal) {
        modal.show(button);
        if (panelId) {
          const accountForms = modal.querySelector('account-forms');
          if (accountForms) {
            accountForms.setAttribute('data-panel', panelId);
          }
        }
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalOpenerAnchor extends HTMLElement {
  constructor() {
    super();

    const anchor = this.querySelector('a');

    if (!anchor) return;
    anchor.addEventListener('click', (event) => {
      if (window.innerWidth > 750) {
        event.preventDefault();
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) {
          if (modal.hasAttribute('open')) {
            modal.hide();
          } else {
            modal.show(anchor);
          }
        }
      }
    });
  }
}
customElements.define('modal-opener-anchor', ModalOpenerAnchor);

class SizeSelectOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      const nextModal = document.querySelector(this.getAttribute('data-next-modal'));
      if (modal && nextModal) {
        modal.setAttribute('data-next-modal', this.getAttribute('data-next-modal'));
        modal.show(button);
      }
    });
  }
}
customElements.define('size-select-opener', SizeSelectOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('click', this.triggerNextModal);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateFindInStore();

    if (this.currentVariant) {
      if (this.dataset.updateUrl === 'false') {
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      } else {
        this.updateURL();
        this.renderProductInfo();
      }
      this.updateVariantInput();
      this.updateWishlistToggles();
      this.updateBackInStock();
      return;
    }

    this.toggleAddButton(true);
    this.setUnavailable();
  }

  updateFindInStore() {
    const findInStoreElement = document.querySelector('find-in-store');
    if (!findInStoreElement) return;

    findInStoreElement.dataset.sku = this.currentVariant?.sku ?? '';

    const storeList = findInStoreElement.querySelector('[data-list-wrapper]');
    if (storeList) storeList.innerHTML = '';

    const autocompleteInput = findInStoreElement.querySelector('#postcode_or_suburb');
    if (autocompleteInput) autocompleteInput.value = '';
  }

  triggerNextModal(event) {
    // Delay is added to ensure the modal is opened after the current variant is set
    setTimeout(() => {
      if (!event.target.closest('input[type="radio"]')) return;

      const findInStoreElement = document.querySelector('find-in-store');
      if (!findInStoreElement || !findInStoreElement.dataset.sku) return;

      const modalWithNextModal = this.closest('[data-next-modal]');
      if (!modalWithNextModal) return;

      const nextModal = document.querySelector(modalWithNextModal.getAttribute('data-next-modal'));
      if (!nextModal) return;

      nextModal.show();
    }, 10);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateWishlistToggles() {
    const productForm = this.closest('product-form');
    if (!productForm) return;

    const wishlistToggles = productForm.querySelectorAll('[data-wishlist-toggle]');
    wishlistToggles.forEach((toggle) => {
      toggle.setAttribute('data-wishlist-product-variant-id', this.currentVariant.id);
      const variantUrl = new URL(toggle.dataset.wishlistProductUrl);
      variantUrl.searchParams.set('variant', this.currentVariant.id);
      toggle.setAttribute('data-wishlist-product-url', variantUrl.toString());
    });
    const variantChangedEvent = new CustomEvent('variantChanged', {
      detail: { variant: this.currentVariant },
      bubbles: true,
    });
    this.dispatchEvent(variantChangedEvent);
  }

  updateBackInStock() {
    const productForm = this.closest('product-form');
    if (!productForm) return;

    const backInStockForms = productForm.querySelectorAll('[data-back-in-stock]');
    backInStockForms.forEach((form) => {
      form.classList.toggle('hidden', this.currentVariant.available);
    });
  }

  updateVariantInput() {
    const productForm = this.closest('product-form');
    if (!productForm) return;

    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked')?.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  removeErrorMessage() {
    const productForm = this.closest('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateMedia(html) {
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
          );

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    document
      .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
      ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media?.id}`);

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const closestButtonContainer = this.parentElement.querySelector('.product-form__buttons');
    if (closestButtonContainer) {
      closestButtonContainer.classList.add('updating');
    }

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateMedia(html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.querySelector('[name="add"]');
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });

        window.Currency?.convertAll?.();

        if (closestButtonContainer) {
          closestButtonContainer.classList.remove('updating');
        }
      });
  }

  toggleAddButton(disable = true, text) {
    const productForm = this.closest('product-form');
    const isWishlistPage = window?.templateSuffix === 'wishlist';
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonDisabledText = productForm.querySelector('[name="add"] > span > span:first-child');
    const addButtonAvailableText = productForm.querySelector('[name="add"] > span > span:last-child');
    if (!addButton) return;
    addButton.removeAttribute('wishlist-variant-id');

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonDisabledText.removeAttribute('aria-hidden');
      addButtonAvailableText.setAttribute('aria-hidden', 'true');
      if (text) addButtonDisabledText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonDisabledText.setAttribute('aria-hidden', 'true');
      addButtonAvailableText.removeAttribute('aria-hidden');

      if (isWishlistPage) {
        const selectedVariantId = this.currentVariant?.id;
        const matchingWishlistItem = window.wishlistItems.find((item) => item.epi === selectedVariantId);
        if (matchingWishlistItem) {
          addButtonAvailableText.textContent = window.variantStrings.wishlist_add_to_cart;
          addButton.setAttribute('wishlist-variant-id', selectedVariantId);
        } else {
          addButtonAvailableText.textContent = window.variantStrings.addToCart;
        }
      } else {
        addButtonAvailableText.textContent = window.variantStrings.addToCart;
      }
    }
  }

  setUnavailable() {
    const productForm = this.closest('product-form');
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonDisabledText = productForm.querySelector('[name="add"] > span > span:first-child');
    const addButtonAvailableText = productForm.querySelector('[name="add"] > span > span:last-child');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonDisabledText.textContent = window.variantStrings.unavailable;
    addButtonDisabledText.removeAttribute('aria-hidden');
    addButtonAvailableText.setAttribute('aria-hidden', 'true');
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class Regionalisation {
  constructor() {
    let _this = this;
    document.querySelectorAll('[data-regionalisation-form]').forEach((form) => {
      form.addEventListener('change', (e) => {
        const isCountry = e.target.name === 'country_code';
        if (isCountry) {
          const selectedOption = e.target.querySelector(':checked') || e.target;
          const selectedStore = selectedOption.dataset.store;
          const newUrl = new URL(selectedStore ? selectedStore : window.location.href);
          newUrl.searchParams.set('country', selectedOption.value);
          return (window.location.href = newUrl.toString());
        }
        form.querySelector('form').submit();
      });
    });
  }
}

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

// Handle Klaviyo Newsletter Susbcription
class KlaviyoNewsletter extends HTMLElement {
  constructor() {
    super();
    this.fetchUrl = this.getAttribute('data-fetch-url');
    this.listId = this.getAttribute('data-list-id');
    this.apiRevision = this.getAttribute('data-api-revision');
    this.source = this.getAttribute('data-source');
    this.form = this.querySelector('form');
    this.successMessage = this.querySelector('.signup__success');
    this.errorMessage = this.querySelector('.signup__error');
    this.form.addEventListener('submit', this.handleSubmit.bind(this));

    this.firstNameInput = this.querySelector('#SignupForm-firstname');
    this.lastNameInput = this.querySelector('#SignupForm-lastname');
    this.phoneInput = this.querySelector('#SignupForm-phone');
    this.countryInput = this.querySelector('#SignupForm-country');
  }

  handleSubmit(event) {
    event.preventDefault();

    const additionalFields = {};
    if (window.customer?.firstName) {
      additionalFields.first_name = window.customer?.firstName;
    }
    if (window.customer?.lastName) {
      additionalFields.last_name = window.customer?.lastName;
    }

    const signupPageFields = {};
    if (this.firstNameInput && this.firstNameInput.value !== '') {
      signupPageFields.first_name = this.firstNameInput.value;
    }

    if (this.lastNameInput && this.lastNameInput.value !== '') {
      signupPageFields.last_name = this.lastNameInput.value;
    }

    if (this.phoneInput && this.phoneInput.value !== '') {
      signupPageFields.phone_number = this.phoneInput.value;
    }

    if (this.countryInput && this.countryInput.value !== '') {
      signupPageFields.location = { country: this.countryInput.value };
    }

    const finalFields = { ...additionalFields, ...signupPageFields };

    const attributes = {
      custom_source: this.source,
      profile: {
        data: {
          type: 'profile',
          attributes: {
            email: this.form.querySelector('input[type="email"]').value,
          },
        },
      },
    };

    if (finalFields.first_name) {
      attributes.profile.data.attributes.first_name = finalFields.first_name;
    }
    if (finalFields.last_name) {
      attributes.profile.data.attributes.last_name = finalFields.last_name;
    }
    if (finalFields.phone_number) {
      attributes.profile.data.attributes.phone_number = finalFields.phone_number;
    }
    if (finalFields.location) {
      attributes.profile.data.attributes.location = finalFields.location;
    }

    const options = {
      method: 'POST',
      headers: { revision: this.apiRevision, 'content-type': 'application/json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: attributes,
          relationships: { list: { data: { type: 'list', id: this.listId } } },
        },
      }),
    };

    fetch(this.fetchUrl, options)
      .then((response) => {
        if (!response.ok) {
          this.errorMessage.classList.remove('hidden');
          throw new Error('Network response was not ok');
        } else {
          this.successMessage.classList.remove('hidden');
        }
      })
      .catch((error) => {
        this.errorMessage.classList.remove('hidden');
        console.error('There has been a problem with your fetch operation:', error);
      });
  }
}

customElements.define('klaviyo-newsletter', KlaviyoNewsletter);

class SizeConversions extends HTMLElement {
  constructor() {
    super();

    this.conversions = JSON.parse(this.getAttribute('conversions'));
    this.productId = this.getAttribute('product-id');
    this.selector = this.querySelector('select');

    const savedConversion = this.loadConversion();

    if (savedConversion) {
      this.updateSizes(savedConversion);
    }

    this.selector.addEventListener('change', (event) => this.handleSelectChange(event));

    // Listen to size conversion changes from other products.
    document.addEventListener('size-conversion-change', (event) => this.updateSizes(event.detail.value));
  }

  handleSelectChange(event) {
    const value = event.target.value;

    this.updateSizes(value);
    this.saveConversion(value);

    // Let other components know the size conversion has changed.
    document.dispatchEvent(
      new CustomEvent('size-conversion-change', {
        bubbles: true,
        detail: {
          value,
        },
      })
    );
  }

  getDefaultSizes() {
    return Object.values(this.conversions)[0];
  }

  getSizes(value) {
    return this.conversions[value] || this.getDefaultSizes();
  }

  updateSizes(value) {
    const defaultSizes = this.getDefaultSizes();

    if (this.selector.value !== value) {
      this.selector.value = value;
    }

    // Limit the scope of which labels this component updates because other products may have a different size conversion.
    const labels = document.querySelectorAll(`[data-size-conversion-product-id="${this.productId}"]`);

    labels.forEach((it) => {
      const originalSize = it.getAttribute('data-size-conversion-size');
      const index = defaultSizes.indexOf(originalSize);
      const updatedSize = this.getSizes(value)[index];
      if (updatedSize) {
        it.textContent = updatedSize;
      }
    });
  }

  loadConversion() {
    try {
      return localStorage.getItem('size-conversion');
    } catch (error) {
      console.warn('Error parsing localStorage:', error);
    }
  }

  saveConversion(value) {
    try {
      localStorage.setItem('size-conversion', value);
    } catch (error) {
      console.warn('Error parsing localStorage:', error);
    }
  }
}

customElements.define('size-conversions', SizeConversions);

document.addEventListener('DOMContentLoaded', () => {
  // Handle Footer Follow-us expand/collapse
  const followUsTrigger = document.querySelector('[data-follow-us-footer-trigger]');
  const followUsPanels = document.querySelectorAll('[data-follow-us-footer-panel]');
  if (!followUsTrigger || !followUsPanels.length > 0) return;

  followUsTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    const heightBuffer = 150;
    const scrollPosition = document.body.scrollHeight + heightBuffer;
    followUsPanels.forEach((panel) => panel.classList.toggle('is-open'));
    setTimeout(() => {
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    }, 250);
  });

  if (typeof Regionalisation !== 'undefined') {
    new Regionalisation();
  }
});
